/* eslint-disable @typescript-eslint/naming-convention */
export enum ParagraphTypes {
    Accordion = 'Accordion',
    AccordionItem = 'AccordionItem',
    AppliancesSearch = 'AppliancesSearch',
    BackLink = 'BackLink',
    Badges = 'Badges',
    BgmButton = 'BgmButton',
    Bigtionaer = 'Bigtionaer',
    Button = 'Button',
    C2aBanner = 'C2aBanner',
    C2aSearch = 'C2aSearch',
    Card = 'Card',
    CardGroup = 'CardGroup',
    Chat = 'Chat',
    CoBrowsingButton = 'CoBrowsingButton',
    ContactData = 'ContactData',
    Cookiebot = 'Cookiebot',
    CustomerSegmentLinks = 'CustomerSegmentLinks',
    DashboardBigtionaer = 'DashboardBigtionaer',
    DownloadList = 'DownloadList',
    Epq = 'Epq',
    FilterableLinkList = 'FilterableLinkList',
    FormOverview = 'FormOverview',
    GapRemover = 'GapRemover',
    GroupedLinkLists = 'GroupedLinkLists',
    GroupedLinkListsCollector = 'GroupedLinkListsCollector',
    Heading = 'Heading',
    HealthInsuranceComparison = 'HealthInsuranceComparison',
    Iframe = 'Iframe',
    Image = 'Image',
    ImageCredits = 'ImageCredits',
    Instruction = 'Instruction',
    InsuranceServices = 'InsuranceServices',
    KeyAccountManager = 'KeyAccountManager',
    KeyAccountManagerSearch = 'KeyAccountManagerSearch',
    Link = 'Link',
    LinkList = 'LinkList',
    LinkListItem = 'LinkListItem',
    List = 'List',
    ListItem = 'ListItem',
    MyBigGeneral = 'MyBigGeneral',
    MyBigGeneralItem = 'MyBigGeneralItem',
    MyBigInbox = 'MyBigInbox',
    MyBigMedicalAppointment = 'MyBigMedicalAppointment',
    MyBigSickNotes = 'SickNotes',
    NewsTeaser = 'NewsTeaser',
    PersonalData = 'PersonalData',
    PublicDelivery = 'PublicDelivery',
    QuickLinkList = 'QuickLinkList',
    SalesPerformance = 'SalesPerformance',
    SalesPerformanceDashboard = 'SalesPerformanceDashboard',
    SearchableLinkList = 'SearchableLinkList',
    ServiceTool = 'ServiceTool',
    SubjectAreas = 'SubjectAreas',
    Table = 'Table',
    Text = 'Text',
    TextButton = 'TextButton',
    UserData = 'UserData',
    UserDetails = 'UserDetails',
    UserDetailsItem = 'UserDetailsItem',
    VideoGroup = 'VideoGroup',
    Webform = 'Webform',
}
